import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
  Modal,
  ModalBody,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { resetLoginFlag } from "../../slices/thunks";
import { login } from "../../slices/qaManagment/authentication/thunk";

import { createSelector } from "reselect";
import { getLoggedInUser } from "../../helpers/fakebackend_helper";

import imageLogo from "../../assets/orderingSystem/login-bg.jpg";
import logo from "../../assets/restroorder.png";
import arrow from "../../assets/schedie/curveArrow.svg";
import MobileSavedUser from "./component/MobileSavedUser";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Login = (props) => {
  const authuser = getLoggedInUser();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
  const loginerror = useSelector((state) => state.Auth.errorMsg);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState(""); // Changed to PascalCase for consistency
  const [passwordShow, setPasswordShow] = useState(false);
  const [showUserSheet, setShowUserSheet] = useState(false);
  const [savedUsers, setSavedUsers] = useState(() => {
    const storedUsers = localStorage.getItem("savedUsers");
    if (!storedUsers) return [];
    const parsedUsers = JSON.parse(storedUsers);

    // Remove duplicates based on email
    const uniqueUsers = parsedUsers.filter(
      (v, i, a) => a.findIndex((u) => u.user.email === v.user.email) === i
    );
    return uniqueUsers;
  });

  const toggleUserSheet = () => setShowUserSheet(!showUserSheet);

  // Get the saved users (parsed into array or default to empty array)

  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));

  const { user, error, errorMsg } = useSelector(loginpageData);
  const [userLogin, setUserLogin] = useState([]);

  useEffect(() => {
    if (user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.user.email;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ""
          : user.user.confirm_password;
      setUserLogin({
        username: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: username, // Initialize with username state
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        console.log("hello");
        setLoading(true);
        dispatch({ type: "LOGIN_LOADING" });

        await dispatch(login(values, props.router.navigate));

        if (
          isAuthenticated && authUser)
          if(
          (authuser.associatedRoles.includes("SuperAdmin") ||
            authuser.associatedRoles.includes("SystemAdmin"))
        ) {
          navigate("/dashboard");
        } else if (
          isAuthenticated &&
          authuser.associatedRoles.includes("SystemUser")
        ) {
          navigate("/pos");
        }
      } catch (error) {
        console.error("Login failed:", error);
      } finally {
        setLoading(false);
        dispatch({ type: "LOGIN_LOADED" });
      }
    },
  });

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  const handleForgotPasswordClick = () => {
    console.log(username);
    navigate("/forgot-password");
  };

  // New handler for card click to auto-fill email
  const handleCardClick = (email) => {
    setUsername(email);
    validation.setFieldValue("username", email);
  };

  // Function to delete a user
  const handleDeleteUser = (email) => {
    const updatedUsers = savedUsers.filter(
      (item) => item?.user?.email !== email
    );
    setSavedUsers(updatedUsers);
    localStorage.setItem("savedUsers", JSON.stringify(updatedUsers));
  };

  document.title = "Central System";
  useEffect(() => {
    if (user) {
      // Get email and roles based on auth type
      const email =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.user.email;

      const roles =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ["User"]
          : user.user.associatedRoles || ["User"];

      // Check if user already exists in savedUsers
      const userExists = savedUsers.some((item) => item.user.email === email);

      if (!userExists) {
        const newUser = { user: { email, roles } };
        const updatedUsers = [...savedUsers, newUser];

        setSavedUsers(updatedUsers);
        localStorage.setItem("savedUsers", JSON.stringify(updatedUsers));
      }
    }
  }, [user]); // Run whenever user changes
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay"></div>

          <div className="shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 1440 120"
            >
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
          </div>
        </div>

        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/#" className="d-inline-block auth-logo ">
                      <img src={logo} alt="" height="60" />
                    </Link>
                  </div>
                  {/* <p className="mt-3 fs-15 fw-semibold">
                    Ordering Management System
                  </p> */}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome Back !</h5>
                      <p className="text-muted">
                        Sign in to continue to ordering management system
                      </p>
                    </div>
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-3">
                          <Label htmlFor="username" className="form-label">
                            Username
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            id="username"
                            name="username"
                            placeholder="Enter username"
                            onChange={(e) => {
                              validation.handleChange(e);
                              setUsername(e.target.value);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.username || ""}
                            invalid={
                              validation.touched.username &&
                              validation.errors.username
                                ? true
                                : false
                            }
                          />
                          {validation.touched.username &&
                          validation.errors.username ? (
                            <FormFeedback type="invalid">
                              {validation.errors.username}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">
                              Forgot password?
                            </Link>
                          </div>
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Password
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              type={passwordShow ? "text" : "password"}
                              className="form-control pe-5 password-input"
                              placeholder="Enter password"
                              id="password-input"
                              name="password"
                              value={validation.values.password || ""}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                              type="button"
                              id="password-addon"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        <div className="form-check">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="auth-remember-check"
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="auth-remember-check"
                          >
                            Remember me
                          </Label>
                        </div>

                        <div className="mt-4">
                          <Button
                            color="success"
                            className="btn btn-success w-100"
                            type="submit"
                            disabled={error ? null : loading ? true : false}
                          >
                            {loading ? (
                              <Spinner size="sm" className="me-2">
                                Loading...
                              </Spinner>
                            ) : null}
                            Sign In
                          </Button>
                        </div>
                        {/* 
                                                <div className="mt-4 text-center">
                                                    <div className="mt-4 text-center mb-4">
                                                        <p className="mb-0">Don't have an account ? <Link to="/auth-signup-basic" className="fw-bold text-primary text-decoration-underline"> Signup </Link> </p>
                                                    </div>
                                                    <div>
                                                        <Button color="primary" className="btn-icon"><i className="ri-facebook-fill fs-16"></i></Button>{" "}
                                                        <Button color="danger" className="btn-icon"><i className="ri-google-fill fs-16"></i></Button>{" "}
                                                        <Button color="dark" className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>{" "}
                                                        <Button color="info" className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>
                                                    </div>
                                                </div> */}
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
